import { Form, Formik } from 'formik'
import cn from 'classnames'
import { Box } from '@components/Box'
import { usePermissionAction } from '@hooks/permission/usePermissionAction'
import { Button } from '@components/Button'
import { ExportButton } from '@components/ExportButton'
import { SelectField } from '@components/forms/SelectField'
import PaymentReportTable from '../PaymentReportTable'
import { ReportOverviewProps } from './interface'

function ReportOverview({
  data,
  total,
  amount,
  initialValues,
  monthOptions,
  yearOptions,
  isLoading,
  monthYear,
  sortBy,
  handleSearch,
  handleSortChange,
  handleWaypointEnter,
  handleReset,
  handleExport,
}: ReportOverviewProps) {
  const permission = usePermissionAction('sale')
  return (
    <>
      <Formik initialValues={initialValues} onSubmit={handleSearch}>
        {() => (
          <Form className='flex gap-x-[20px] mb-[30px]'>
            <SelectField
              name='month'
              options={monthOptions}
              label='เดือน'
              className='w-[132px]'
            />
            <SelectField
              name='year'
              options={yearOptions}
              label='ปี'
              className='w-[92px]'
            />
            <div className='flex-1 text-[14px] flex justify-end items-center gap-x-[20px]'>
              <Button
                className='underline text-secondary !px-0'
                type='reset'
                onClick={handleReset}
              >
                ล้างค่า
              </Button>
              <Button className='bg-secondary text-white' type='submit'>
                ค้นหา
              </Button>
              <ExportButton
                handleClick={handleExport}
                className={cn({
                  hidden: !permission.download || !handleExport,
                })}
              />
            </div>
          </Form>
        )}
      </Formik>
      {initialValues.submit ? (
        <PaymentReportTable
          data={data}
          total={total}
          amount={amount}
          monthYear={monthYear}
          sortBy={sortBy}
          isLoading={isLoading}
          handleSortChange={handleSortChange}
          handleWaypointEnter={handleWaypointEnter}
        />
      ) : (
        <Box>
          <div className='flex'>
            <div className='flex flex-col items-center justify-center w-full text-secondary-100'>
              <p className='text-[24px] px-[93px] mb-[8px] font-mitr text-secondary-50 flex justify-center font-medium'>
                เลือกช่วงเวลาแล้วกดค้นหาเพื่อดูข้อมูล
              </p>
            </div>
          </div>
        </Box>
      )}
    </>
  )
}

export default ReportOverview
